/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListConvenienceDoorsQueryResponse,
  ListConvenienceDoorsQueryParams,
} from '../types/ListConvenienceDoors'

function getListConvenienceDoorsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/places/convenience-doors/` as const,
  }
  return res
}

/**
 * @summary List convenience doors
 * {@link /api/v1/places/convenience-doors/}
 */
export async function listConvenienceDoors(
  params?: ListConvenienceDoorsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListConvenienceDoorsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListConvenienceDoorsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
